import Vue from 'vue';
import Vuex from 'vuex';
import common from './modules/common';
import account from './modules/account';
import check from './modules/check';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    common,
    account,
    check
  }
});
